<template>
<!-- 个人信息管理 -->
<div class="geren">
<!-- <span>个人信息管理</span> -->
<!-- <div class="left"></div> -->
<el-row>
  <el-col :span="10" :offset="6"><div class="content">
<h2>个人中心</h2>
<!-- <span>{{ gteNum }}</span> -->
<img :src="geren.context.HeadImage" alt="欢迎您的到来">
<ul>
  <li>
  <span>昵称</span><span>{{ geren.context.NickName }}</span>
  <span @click="Name()">修改</span>
  <!-- <span>修改</span> -->
  <!-- {{ geren.context.username }} -->
  </li>
  <li>
  <span>账号</span><span>{{ geren.context.username }} </span>
  <!-- <span>修改</span> -->
  <!-- {{ geren.context.username }} -->
  </li>
<li>
<span>手机号</span><span>{{ geren.context.mobile }}</span>
<!-- <span>修改</span> -->
</li>
<li>
<span>密码</span><span>***********</span>
<span @click="dialog = true">修改</span>
</li>
<li>
<span>点数</span><span>{{ geren.context.points }} 点</span>
<span ><router-link to="/pay" style="color: red;"> 前往充值 </router-link></span>
</li>

<el-button type="primary" plain @click="info()">查看订单</el-button>

<!-- {{ geren.context.mobile }} -->
</ul>
</div></el-col>
</el-row>
<el-drawer
  title="您正在修改密码,请慎重考虑"
  :before-close="handleClose"
  :visible.sync="dialog"
  direction="ltr"
  custom-class="demo-drawer"
  ref="drawer"
  >
  <div class="demo-drawer__content">
    <el-form :model="form">
      <el-form-item label="旧密码:" prop="passwprd" :label-width="formLabelWidth">
        <el-input type="password" v-model="form.old_password" autocomplete="off" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码:" prop="passwprd" :label-width="formLabelWidth">
        <el-input type="password" v-model="form.new_password" autocomplete="off" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="再次确认:" prop="passwprd" :label-width="formLabelWidth">
        <el-input type="password" v-model="form.new_password2" autocomplete="off" placeholder="请输入密码"></el-input>
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer">
      <el-button @click="cancelForm">取 消</el-button>
      <el-button type="primary" @click="$refs.drawer.closeDrawer()" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
    </div>
  </div>
</el-drawer>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
data() {
  var validatePass = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入密码'));
    } else {
      if (this.ruleForm.checkPass !== '') {
        this.$refs.ruleForm.validateField('checkPass');
      }
      callback();
    }
  };
    return {
      table: false,
      dialog: false,
      loading: false,
      form: {
        old_password:'',
        new_password:'',
        new_password2:''
      },
      formLabelWidth: '90px',
      timer: null,
      rules: {
        new_password: [
          { validator: validatePass, trigger: 'blur' }
        ],
      }
    };
  },
  created() {
this.$store.dispatch('getInfo',this.$cookie.get('token'))
// console.log(navigator.userAgent.indexOf('AppleWebKit') > -1)
this.handleResizeing()
},
beforeRouteEnter(to, from ,next) {
  to,
  from,
  next()
},
  methods:{
// 加入订单详情
info() {
  // console.log(this.$cookie.get('token'));
  let token = this.$cookie.get('token');
  // console.log(token)
  this.$router.push('/order/id=' + token)
},
    // 修改名字
Name() {
this.openName()
},
openName() {
        this.$prompt('请输入新的昵称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // inputPattern: ^{4,10},
          inputErrorMessage: '昵称长度必须2到5位'
        }).then(({ value }) => {
          // console.log(value.length)
          if(value.length <= 5) {
            let data ={
              nick_name : value.toString(),
             token : this.$cookie.get('token').toString()
            }
            // console.log(data)
            this.$store.dispatch('PostName',data).then((res) => {
              // console.log(res)
              //
              if(res.data.code == 0) {
                sessionStorage.setItem('TwoName',data.nick_name)
                this.$message({
                          message: '恭喜你，你的昵称修改成功',
                          type: 'success'
                        });
                setTimeout(() => {
                  this.$router.push('/');
                  window.location.reload()
                },2000)
              }
            })
          } else {
            this.$message.error('修改失败');
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
//判断是否是pc
handleResizeing() {

      if(window.outerWidth >= 1000) {
        this.open("欢迎您")
      }else {
        this.$router.push("/")
        this.open('请使用电脑登录,手机暂不支持')
      }
},
handleClose(done) {
      if (this.loading) {
        return;
      }
      this.$confirm('确定要提交表单吗？')
        .then(_ => {
          console.log(_)
          // console.log(this.form)
          this.loading = true;
          this.timer = setTimeout(() => {
            done();
            // 动画关闭需要一定的时间
            setTimeout(() => {
              this.loading = false;
            }, 400);
          }, 2000);
          // 判断不能为空
          var reg=/^1[3456789]\d{9}$/;
          if(this.form.old_password == '' && this.form.new_password == '' &&  this.form.new_password2 == '' && reg.test(this.form.new_password) && this.form.new_password2 === this.form.new_password &&  this.form.new_password != this.form.old_password) {
            // console.log("成功")
            console.log('失败')
            // alirt("失败")
            this.open('密码存在问题,请仔细检查')
          }else {
            console.log("成功")
            // 发送的数据
            let data ={
              old_password:this.form.old_password.toString(),
              new_password:this.form.new_password.toString(),
              new_password2:this.form.new_password2.toString(),
              token:this.$cookie.get('token').toString()
            };
            // console.log(data)
            // 发送请求
            this.$store.dispatch('passRemove',data).then((res) => {
              // console.log(res)
              // 判断登录状态
              if(res.data.code == 0) {
                // this.open(res.data.change_pwd_weemsg, res.data.code)
                this.$cookie.delete('token')
               setTimeout(() => {
                  this.$router.push('/login')
                  window.location.reload()
                },1000)
              }else {
                console.log("修改不成功")
                setTimeout(() => {
                  this.open("修改失败,可能你输入的有问题")
                },1000)
              }
            })
          }
        })
        .catch(_ => {
          console.log(_)
        });
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
// 定义一个函数,提示的作用
 open(one) {
        this.$alert(one, "提示", {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
      },
// 修改密码
remove() {
// this.$store.dispatch('passRemove',this.$cookie.get('token'))
},
},
  computed: {
    geren() {
      return this.$store.state.InfoModule.geren
    },
    // code () {
    //   return this.$store.state.InfoModule.getters.gteNum
    // },
    ...mapGetters(['gteNum']),
    // ...mapGetters(['geren'])

  }
}
</script>

<style scoped lang="scss">
.geren {
  width: 100%;
  height: 80vh;
  background-color: #fff;
  .content {
    height: 9rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    background-color: #f5f8fa;
    border-radius: 12px;
    overflow: hidden;
    h2 {
      margin-top: 0.2rem;
      color: #3268ce;
    }
    img {
      margin-top: 0.5rem;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      transition: all 0.5s;
    }
    img:hover {
      // transform: scale(1.5);
      transform: rotateY(180deg);
    }
    ul {
      width: 80%;
      height: 80%;
      // background-color: yellow;
      margin: 0.5rem auto;
      li {
        width: 100%;
        height: 10%;
        // background-color: red;
        text-align: left;
        font-size: 0.3rem;
        // line-height: 20px;
        margin-top: 0.1rem;
        span {
          margin-right: 0.7rem;
        }
        span:nth-child(2) {
          color: #3268CE;
        }
        span:nth-child(2):hover {
          color: blue;
        }
        span:last-child {
          color: #3268CE;
          float: right;
          }
      }
    }
  }
}
</style>
